
window.addEventListener("DOMContentLoaded", () => {
    // global prices are not defined here anymore.
});

/* ### Helper Functions to get price dependent on material thickness ############################################################ */

function lpoGetPricePerMeterForEdgeFinishing(options) {
    let materialThickness = lpoGetMatrialThickness(options);
    return window.lpoGetPricePerEdgeFinishing[materialThickness];
}

function lpoGetPricePerMeterForUndersideFinishing(options) {
    let materialThickness = lpoGetMatrialThickness(options);
    return window.lpoPricesPerUndersideFinishingPerM[materialThickness];
}

function lpoGetPriceForCornerRadius(options) {
    let materialThickness = lpoGetMatrialThickness(options);
    return window.lpoPricesPerCorner[materialThickness];
}

function lpoGetPriceForWindowSillEdgeFinishing(options) {
    let materialThickness = lpoGetMatrialThickness(options);
    return window.lpoPricesPerWindowSillEdgeFinishing[materialThickness];
}

function lpoGetPriceForWindowSillAusklinkung(options) {
    let materialThickness = lpoGetMatrialThickness(options);
    return window.lpoPricesPerWindowSillAusklinkung[materialThickness];
}

window.addEventListener('option:changed', function (e) {

    var option = e.detail;

    if (option.name == 'Materialdicke') {
        setProductPriceInRelationToMaterialThickness(option.value);
    }

});

function setProductPriceInRelationToMaterialThickness(thicknessValue) {
    if (thicknessValue == '2cm') {
        window.lpoMyProductSquarePrice = window.lpoMyProductSquarePrice2cm;
    } else if (thicknessValue == '3cm') {
        window.lpoMyProductSquarePrice = window.lpoMyProductSquarePrice3cm;
    }
}

function lpoGetMatrialThickness(options) {
    return options.value('Materialdicke')
}

function lpoAddWeightToProductOptions(area, options) {
    let newWeight = 65 * area; // calculation of weight in kilograms
    // console.log('newWeight:' + newWeight);
    let weightReturnVal = options.weight('Materialdicke', newWeight);
    // console.log('weightReturnVal:' + weightReturn);
}

function lpoCalculateProductPrice(x, y, area, options) {

    lpoAddWeightToProductOptions(area, options);

    var lengthCm = x;
    var widthCm = y;

    // calculate square price
    // console.log(options);

    /* ### Basis-Preis (Materialdicke, Oberfläche) ########################################################## */

    var squarePrices = window.lpoMyProductSquarePrices

    // get material thickness and base square price
    var materialThickness = options.value('Materialdicke');
    var squarePriceBase = squarePrices[materialThickness];
    // console.log('squarePriceBase: ' + squarePriceBase);

    // get Surface-Treatment
    var surfaceChosen = options.value('Oberfläche');
    var squarePriceAddForSurface = 0;
    if (typeof surfaceChosen != 'undefined' && surfaceChosen != '') {
        surfaceChosen = surfaceChosen.toLowerCase();
        // Start: new code
        if (surfaceChosen.includes('antik')) {
            surfaceChosen = 'antik';
        }
        // End: new code
        squarePriceAddForSurface = window.lpoMySurfacePrices[surfaceChosen];
    }
    // console.log('squarePriceAddForSurface: ' + squarePriceAddForSurface);

    // calculate complete square price
    var squarePriceComplete = squarePriceBase + squarePriceAddForSurface;
    // console.log('squarePriceComplete: ' + squarePriceComplete);

    // calculate preliminary price
    var price = squarePriceComplete * area;
    // console.log('price: ' + price);

    /* ### Get Preise Kantenbearbeitung, Untersicht, Ecken ########################################################## */

    var pricePerMeterEdgeFinishing = lpoGetPricePerMeterForEdgeFinishing(options);
    // console.log('pricePerMeterEdgeFinishing: ' + pricePerMeterEdgeFinishing);

    /* ### Tischplatte, Ablage, Mauerabdekcung - Kantenbearbeitung, Untersicht, Ecken ########################################################## */

    if (options.value('Anwendungszweck') == 'Fensterbank innen' || options.value('Anwendungszweck') == 'Fensterbank außen') {

        // Fensterbank - Kantenbearbeitung
        var pricePerrWindowSillEdgeFinishing = lpoGetPriceForWindowSillEdgeFinishing(options);
        var priceForWindowSillEdgeFinishing = lpoGetPriceForWindowsillOptionalExtras(options, "Fensterbank_Kantenbearbeitung", 'standard', 'Fensterbank_Kantenbearbeitung_Auswahl', pricePerrWindowSillEdgeFinishing);
        // console.log('priceForWindowSillEdgeFinishing: ' + priceForWindowSillEdgeFinishing);

        // Fensterbank - Kantenbearbeitung
        var pricePerWindowSillAusklinkung = lpoGetPriceForWindowSillAusklinkung(options);
        var priceForWindowSillAusklinkungen = lpoGetPriceForWindowsillOptionalExtras(options, "Ausklinkung", 'nein', 'Ausklinkung Details', pricePerWindowSillAusklinkung);
        // console.log('priceForWindowSillAusklinkungen: ' + priceForWindowSillAusklinkungen);

        // Fensterbank - Ecken Abrunden
        var priceForWindowSillCornerRounding = lpoGetPriceForCornerRounding(options, true);
        // console.log('priceForWindowSillCornerRounding: ' + priceForWindowSillCornerRounding);

        // update calculated price
        price = price + priceForWindowSillEdgeFinishing + priceForWindowSillAusklinkungen + priceForWindowSillCornerRounding;

        // nur Fensterbank außen: Wasserrille
        if (options.value('Anwendungszweck') == 'Fensterbank außen') {
            var priceForDripGrooves = lpoCalculatePriceForDripGrooveForWindowSill(options, lengthCm, widthCm);
            // console.log('priceForDripGrooves: ' + priceForDripGrooves);
            price += priceForDripGrooves;
        }

    } else {

        // Kantenbearbeitung
        var priceForEdgeFinishing = lpoGetPriceForSideTreatment(options, 'Kantenbearbeitung', 'Nur bestimmte Kanten schleifen?', 'Kantenauswahl', lengthCm, widthCm, pricePerMeterEdgeFinishing);
        // console.log('priceForEdgeFinishing: ' + priceForEdgeFinishing);

        // Untersicht schleifen
        var pricePerMeterForUndersideFinishing = lpoGetPricePerMeterForUndersideFinishing(options);
        // console.log('pricePerMeterForUndersideFinishing: ' + pricePerMeterForUndersideFinishing);
        var priceForUndersideFinishing = lpoGetPriceForSideTreatment(options, 'Untersicht schleifen', 'Untersicht schleifen - nur bestimmte Kanten?', 'Untersicht schleifen - Kantenauswahl', lengthCm, widthCm, pricePerMeterForUndersideFinishing);
        // console.log('priceForUndersideFinishing: ' + priceForUndersideFinishing);

        // Ecken abrunden
        var priceCornerRounding = lpoGetPriceForCornerRounding(options);
        // console.log('priceCornerRounding: ' + priceCornerRounding);

        // Werkstücke draußen: Wasserrille berechnen
        var priceForDripGrooves = lpoCalculatePriceForDripGrooveRect(options, lengthCm, widthCm);
        // console.log('priceForDripGrooves: ' + priceForDripGrooves);

        // update calculated price
        price = price + priceForEdgeFinishing + priceForUndersideFinishing + priceCornerRounding + priceForDripGrooves;
    }

    // console.log('final price: ' + price);
    return price;
}

function lpoGetPriceForWindowsillOptionalExtras(options, mainOptionName, mainOptionValNoextra, optionNameDetailChoices, pricePerOption) {

    if (options.value(mainOptionName).toLowerCase() == mainOptionValNoextra.toLowerCase()) {
        return 0;
    }

    let choiceWindowSillEdgesStr = options.value(optionNameDetailChoices)
    if (choiceWindowSillEdgesStr.length == 0) {
        return 0;
    }
    let choiceWindowSillEdgesArr = choiceWindowSillEdgesStr.split(',')
    let numberOfEdges = choiceWindowSillEdgesArr.length;

    return numberOfEdges * pricePerOption;
}

function lpoCalculatePriceForDripGrooveForWindowSill(options, windowSillLengthCm, windowSillWidthCm) {

    let windowSillLengthMeter = windowSillLengthCm / 100;
    let windowSillWidthMeter = windowSillWidthCm / 100;

    let dripGrooveChoiceStr = options.value('Fensterbank_Wasserrille');
    if (dripGrooveChoiceStr.length == 0) {
        return 0;
    }

    let dripGrooveChoiceArr = dripGrooveChoiceStr.split(',')

    let dripGrooveLength = 0;

    dripGrooveChoiceArr.forEach(function (choice, i, dripGrooveChoiceArr) {
        if (choice == 'oben2x') {
            dripGrooveLength += windowSillWidthMeter * 2;
        } else if (choice == 'unten') {
            dripGrooveLength += windowSillLengthMeter;
        }
    });

    if (dripGrooveLength == 0) {
        return 0;
    }

    // console.log('drip groove length: ' + dripGrooveLength);

    return calculateTotalPriceForDripGrooveLength(dripGrooveLength);
}

function lpoCalculatePriceForDripGrooveRect(options, lengthCm, widthCm) {


    let dripGrooveChoice = options.value('Wasserrille');

    if (dripGrooveChoice == '' || dripGrooveChoice.length == 0) {
        return 0;
    }

    if (dripGrooveChoice.toLowerCase() != 'ja') {
        return 0;
    }

    let lengthM = lengthCm / 100;
    let widthM = widthCm / 100;

    // calcluate all side lengths of the rectangular
    let totalDripGrooveLength = 2 * lengthM + 2 * widthM;
    // console.log('totalDripGrooveLength: ' + totalDripGrooveLength);

    return calculateTotalPriceForDripGrooveLength(totalDripGrooveLength);
}

function calculateTotalPriceForDripGrooveLength(dripGrooveLength) {
    // get prices and min-drip-groove-length
    let minDripGrooveLength = window.lpoMinLengthDripGroove;
    let pricePerMeterDripGroove = window.lpoPricePerMeterDripGroove;

    if (dripGrooveLength < minDripGrooveLength) {
        dripGrooveLength = minDripGrooveLength;
        // console.log('apply minimum-drip-groove-length (because length is not big enough): ' + dripGrooveLength);
    }

    return pricePerMeterDripGroove * dripGrooveLength;
}

/* ### Preisberechnung Ecken Abrunden ############################################################ */

function lpoGetPriceForCornerRounding(options, isWindowSill) {

    if (typeof isWindowSill == 'undefined') {
        isWindowSill = false;
    }

    let standardNumberOfCorners = isWindowSill ? 2 : 4;

    let pricePerCorner = lpoGetPriceForCornerRadius(options);
    // console.log('pricePerCorner:' + pricePerCorner);

    let roundCorners = isWindowSill ? options.value('Fensterbank - Ecken abrunden').toLowerCase() : options.value('Ecken abrunden').toLowerCase();
    if (!roundCorners.startsWith('ja')) {
        return 0;
    }

    // if all corners should be rounded, then give back standardNumberOfCorners times the price per corner
    let onlyCertainCorners = isWindowSill ? options.value('Fensterbank - Bestimmte Ecken abrunden?').toLowerCase() : options.value('Bestimmte Ecken abrunden?').toLowerCase();
    if (!onlyCertainCorners.startsWith('ja')) {
        return standardNumberOfCorners * pricePerCorner;
    }

    // in the case if corners are chosen, calculate the numbers of chosen corners and multiply this with the price per corner
    let cornersChosen = isWindowSill ? options.value('Fensterbank - Auswahl für Eckenabrundung').toLowerCase() : options.value('Auswahl für Eckenabrundung').toLowerCase();
    let numberOfCornersChosen = 0;
    if (cornersChosen.length != 0) {
        let cornersChosenArr = cornersChosen.split(',');
        numberOfCornersChosen = cornersChosenArr.length;
    }
    // console.log('numberOfCornersChosen: ' + numberOfCornersChosen);

    return numberOfCornersChosen * pricePerCorner;
}

/* ### Preisberechnung Kantenbearbeitung & Untersicht schleifen ############################################################ */

function lpoGetPriceForSideTreatment(options, optionNameBase, optionNameCertainSides, optionNameChoice, lengthCm, widthCm, pricePerMeter, minLengthForCalc) {

    if (typeof (minLengthForCalc) == 'undefined') {
        var minLengthForCalc = 1;
    }

    let edgeFinishingOptVal = options.value(optionNameBase).toLowerCase();

    if (!edgeFinishingOptVal.startsWith('ja')) {
        return 0;
    }

    // if all edges are chosen
    let onlyCertainEdges = options.value(optionNameCertainSides).toLowerCase();
    if (!onlyCertainEdges.startsWith('ja')) {
        let lengthForFinishing = lpoCalculateRectShapeLengthInMeter(lengthCm, widthCm);
        return getCalculatedPriceForLength(lengthForFinishing, pricePerMeter, minLengthForCalc);
    }

    // if only certain edges are chosen
    let edgesForFinishing = options.value(optionNameChoice);
    let totalLengthSelected = lpoCalculateRectLengthForCertainSides(edgesForFinishing, lengthCm, widthCm);

    // special case, if no length is selected yet (then do not take into account the minimum-length for calculation):
    if (totalLengthSelected == 0) {
        return 0;
    }

    return getCalculatedPriceForLength(totalLengthSelected, pricePerMeter, minLengthForCalc);
}

function getCalculatedPriceForLength(length, pricePerLength, minLengthForCalc) {
    if (length > minLengthForCalc) {
        return length * pricePerLength;
    }
    return minLengthForCalc * pricePerLength;
}

function lpoCalculateRectShapeLengthInMeter(lengthCm, widthCm) {
    let widthM = widthCm / 100;
    let lengthM = lengthCm / 100;
    return 2 * widthM + 2 * lengthM;
}

/*
 * Input is a string like "A,B,D" or "A,D", 
 * where A and C is the length of the shape
 * and B and D is the width 
 */
function lpoCalculateRectLengthForCertainSides(sidesStr, lengthCm, widthCm) {

    if (sidesStr == '') {
        // return 0, because no edge is selected
        return 0;
        // return lpoCalculateRectShapeLengthInMeter(lengthCm, widthCm);
    }

    let widthM = widthCm / 100;
    let lengthM = lengthCm / 100;

    sidesStr = sidesStr.toLowerCase();
    sidesArr = sidesStr.split(',');

    let totalLengthInM = 0;

    sidesArr.forEach(function (side, i, arr) {
        if (side == 'a' || side == 'c') {
            totalLengthInM += lengthM;
        } else {
            totalLengthInM += widthM;
        }
    });

    // console.log('totalLengthInM: ' + totalLengthInM);
    return totalLengthInM;

}